import React, { FC } from 'react';

import Link from '@/presentation/link';
import SStickyBar, { SStickyBarWrapper } from '@/components/sticky-bar/StickyBar.styled';
import { ISelectedItem } from '@/hooks/useGridSelection';
import Text from '@/presentation/text';

interface IStickyBarProps {
  selectedItemType: string;
  selectedCount: number;
  children?: React.ReactNode;
  setSelectedState?: (selectedState: ISelectedItem) => void;
}

const StickyBar: FC<IStickyBarProps> = ({
  selectedCount,
  selectedItemType,
  children = null,
  setSelectedState = () => 0,
}) => {
  const renderNrOfSelectedItems = () => {
    const selectedText = selectedCount
      ? `${selectedCount} ${selectedItemType}${selectedCount === 1 ? '' : 's'} selected`
      : `No ${selectedItemType}s selected`;

    return (
      <div className="selected-items">
        <Text id="lblSelectedMsgs" size="xxs">
          {selectedText}
        </Text>
        {selectedCount ? (
          <Link
            id="lnkClearSelection"
            icon="faArrowRotateBackward"
            noUnderline
            label="Clear Selection"
            onClick={() => {
              setSelectedState({});
            }}
          />
        ) : null}
      </div>
    );
  };

  return (
    <SStickyBarWrapper>
      <SStickyBar className={`${selectedCount ? 'has-selected-items' : ''}`}>
        {renderNrOfSelectedItems()}
        <div className="actions-buttons">{children}</div>
      </SStickyBar>
    </SStickyBarWrapper>
  );
};

export default StickyBar;
